import * as requests from './requests'
import constants from './constants'
import urls from './urls'

// Descuentos
export async function getDescuentos() {
  return requests.get(constants.API_URL_MARKETING, urls.GET_DESCUENTOS).then(async response => {
    return { ok: response.ok, data: await response.json() }
  })
}

export async function setDescuentoUsado(payload) {
  return requests
    .put(constants.API_URL_MARKETING, urls.PUT_DESCUENTO_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteDescuento(payload) {
  return requests
    .remove(constants.API_URL_MARKETING, `${urls.DELETE_DESCUENTO_BY_ID}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function getDescuentoById(payload) {
  return requests
    .get(
      constants.API_URL_MARKETING,
      `${urls.GET_DESCUENTO_BY_ID_INCLUDE_DESCUENTOS}?id=${payload}`,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertDescuento(payload) {
  return requests
    .post(constants.API_URL_MARKETING, urls.INSERT_DESCUENTO, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateDescuento(payload) {
  return requests
    .put(constants.API_URL_MARKETING, urls.UPDATE_DESCUENTO, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getDescuentosFiltered(payload) {
  return requests
    .post(constants.API_URL_MARKETING, urls.GET_DESCUENTOS_FILTERED, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Imagen Descuento
export async function getImagenDescuentoWithImage(idiomaId) {
  return requests
    .get(constants.API_URL_MARKETING, `${urls.GET_IMAGENDESCUENTO_WITH_IMAGE}?idiomaId=${idiomaId}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertImagenDescuento(payload) {
  return requests
    .postForm(constants.API_URL_MARKETING, urls.INSERT_IMAGENDESCUENTO, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}
